import { ReactNode, useCallback } from "react";
import FixaFocusLock from "@coworker/apprestructured/src/shared/wrappers/FixaFocusLock/FixaFocusLock";
import styles from "./Fullscreen.module.css";

type FullscreenProps = {
  onEscaped?: () => void;
  className?: string | undefined;
  children: ReactNode;
};

function Fullscreen({ onEscaped, className, children }: FullscreenProps) {
  const combinedClassName = className
    ? `${styles["root"]} ${className}`
    : styles["root"];

  const handleEscaped = useCallback(() => {
    if (onEscaped) onEscaped();
  }, [onEscaped]);

  return (
    <FixaFocusLock onEscaped={handleEscaped} locked={true} autoFocus={false}>
      <div className={combinedClassName}>{children}</div>
    </FixaFocusLock>
  );
}

export default Fullscreen;
